export default __webpack_public_path__ + "static/media/5.ebeac440.jpg";